jQuery(document).ready(function ($) {

    $('.navigation-mobile').on("click", function () {
        $(this).toggleClass("active");
    });

    // Prevent background scroll when mobile menu is open
    $('.hamburger-container').on('click', function() {
            $('body').toggleClass('no-scroll');
    });

    $('.question').on("click", function () {
        $(this).toggleClass("question__open");
    });

    // Add arrow for links with children
    $('.menu-item-has-children').each(function () {
        $('<i class="arrow-down"></i>').prependTo(this).on("click", function (e) {
            e.stopPropagation();
            $(this).toggleClass("arrow-down__open");
            $(this).siblings('.sub-menu').slideToggle();
        });
    });

    // get correct mobile window size
    function updateViewportHeight() {
        let vh = $(window).innerHeight() * 0.01;
        $('html').css('--vh', vh + 'px');
    }

    $(window).on('resize', updateViewportHeight);
    updateViewportHeight();
});




